import React from 'react';
import { Grid } from '~/shared/components/Grid/Grid';
import { Container } from '~/shared/components/Container';
import ProfileSidebar from '../ProfileSidebar/ProfileSidebar';
import ProfileContent from '../ProfileContent/ProfileContent';
import styles from './ProfileLayout.module.scss';
import { MaxWidth } from '~/shared/components/MaxWidth';

const ProfileLayout: React.FC = () => {
    return (
        <div className={styles.container}>
            <Container>
                <MaxWidth>
                    <Grid className={styles.grid} flow="column" columns="1fr 3fr">
                        <ProfileSidebar />
                        <ProfileContent />
                    </Grid>
                </MaxWidth>
            </Container>
        </div>
    );
};

export default ProfileLayout;
